export enum TriageTemplateChangeSetting {
	Disallow = "disallow",
	Keep = "keep",
	Remove = "remove",
	Prompt = "prompt"
}

export interface TriageTemplateChangeSettingOption {
	id: string
	title: string
}

export const TriageTemplateChangeSettingOptions: TriageTemplateChangeSettingOption[] = [
	{
		id: "disallow",
		title: "Do not allow Template change"
	},
	{
		id: "keep",
		title: "Allow change, keep Fields no longer on new Template"
	},
	{
		id: "remove",
		title: "Allow change, remove Fields no longer on new Template"
	},
	{
		id: "prompt",
		title: "Allow change, ask user for Field choice"
	}
]
